import React, { useState, useRef } from "react";
import { BrowserRouter as Router, Routes, Route, Link, Navigate,  useNavigate, useLocation } from 'react-router-dom';
import { auth } from './firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup, getAdditionalUserInfo } from 'firebase/auth';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useTranslation } from 'react-i18next';
import { useEffect } from "react";
import './App.css';
import { getFirestore, Timestamp, arrayUnion } from "firebase/firestore";
import { checkUserSubscription } from './subscription';
import { db } from './firebase';
import { doc, setDoc, getDoc, updateDoc, onSnapshot  } from "firebase/firestore";
// Usage: In your Instructions.jsx
// === INSTRUCTIONS PAGE COMPONENT ===
import { motion, AnimatePresence } from "framer-motion";
import { 
  ArrowForward, 
  ArrowBack,
  Download, 
  Payment, 
  Web, 
  TableChart, 
  Settings, 
  Refresh, 
  Update 
} from "@mui/icons-material";
import PaymentSuccess from './PaymentSuccess';  // CORRECT
import {
  Box,
  Container,
  Grid,
  Stack,
  Paper,
  Typography,
  Button,
  Avatar,
  TextField,   
} from "@mui/material";





// src/pages/RefundPolicy.js



function PaymentandRefundPolicy() {
  const { t } = useTranslation();

  return (
    <div style={{
      maxWidth: 1040,
      minwidth: 940,
      margin: "64px auto",
      padding: "52px 40px 56px 40px",
      background: "#fff",
      borderRadius: 22,
      boxShadow: "0 8px 35px #b3def229",
      fontFamily: '"Inter", "Segoe UI", Arial, sans-serif'
    }}>
      <h1 style={{
        fontWeight: 900,
        color: "#1786c7",
        fontSize: 38,
        marginBottom: 36,
        letterSpacing: ".012em"
      }}>
        {t('refundPolicy.title')}
      </h1>
      <div style={{
         // Large, responsive font
        color: "#222d47",
        fontWeight: 400,
        fontSize: "clamp(16px, 1.4vw, 20px)",
        lineHeight: 1.68,
        marginBottom: 22,
        textAlign: "left",
        maxWidth: 940
      }}>
        <span dangerouslySetInnerHTML={{ __html: t('refundPolicy.policy') }} />
      </div>
      <hr style={{
        margin: "44px 0 0 0",
        border: "none",
        height: "2px",
        background: "linear-gradient(90deg,#b3def6 60%,#1786c7 100%)",
        borderRadius: 2
      }} />
    </div>
  );
}




function AboutCompany() {
  const { t } = useTranslation();

  return (
    <div style={{
      maxWidth: 1040,
      minwidth: 940,
      margin: "64px auto",
      padding: "52px 40px 56px 40px",
      background: "#fff",
      borderRadius: 22,
      boxShadow: "0 8px 35px #b3def229",
      fontFamily: '"Inter", "Segoe UI", Arial, sans-serif'
    }}>
      <h1 style={{
        fontWeight: 900,
        color: "#1786c7",
        fontSize: 38,
        marginBottom: 36,
        letterSpacing: ".012em"
      }}>
        {t('legal.about_title')}
      </h1>
      <div style={{
        fontSize: "clamp(16px, 1.4vw, 20px)",
        color: "#222d47",
        fontWeight: 400,
        lineHeight: 1.68,
        marginBottom: 19,
        maxWidth: 940
      }}>
        {/* {t('legal.about_idcode')}:<span style={{ color: "#17548a", fontWeight: 700 }}>B24147753</span><br /> */}
        {t('legal.about_company_1')}<br /><br />
        {t('legal.about_company_2')}<br /><br />
        {t('legal.about_company_3')}<br /><br />
      </div>
    </div>
  );
}






function TermsConditions() {
  const { t } = useTranslation();

  return (
    <div style={{
      maxWidth: 1040,
      minwidth: 940,
      margin: "64px auto",
      padding: "52px 40px 56px 40px",
      background: "#fff",
      borderRadius: 22,
      boxShadow: "0 8px 35px #b3def229",
      fontFamily: '"Inter", "Segoe UI", Arial, sans-serif'
    }}>
      <h1 style={{
        fontWeight: 900,
        color: "#1786c7",
        fontSize: 38,
        marginBottom: 36,
        letterSpacing: ".012em"
      }}>
        {t('legal.terms_title')}
      </h1>
      <div style={{
        fontSize: "clamp(16px, 1.4vw, 20px)",
        color: "#222d47",
        fontWeight: 400,
        lineHeight: 1.68,
        marginBottom: 19,
        maxWidth: 940
      }}>
        {t('legal.terms_intro')}
<ul>
  <li dangerouslySetInnerHTML={{ __html: t('legal.terms_accurate') }} />
  <li dangerouslySetInnerHTML={{ __html: t('legal.terms_payment_security') }} />
  <li dangerouslySetInnerHTML={{ __html: t('legal.terms_recurring') }} />
  <li dangerouslySetInnerHTML={{ __html: t('legal.terms_access') }} />
  <li dangerouslySetInnerHTML={{ __html: t('legal.terms_security') }} />
  <li dangerouslySetInnerHTML={{ __html: t('legal.terms_refund') }} />
  <li dangerouslySetInnerHTML={{ __html: t('legal.terms_updates') }} />
  <li dangerouslySetInnerHTML={{ __html: t('legal.terms_changes') }} />
  <li dangerouslySetInnerHTML={{ __html: t('legal.terms_law') }} />
  <li>
    <span dangerouslySetInnerHTML={{ __html: t('legal.terms_contact')}} />
    <br/>
    <span dangerouslySetInnerHTML={{ __html: t('legal.terms_accept')}} />
  </li>
</ul>

      </div>
    </div>
  );
}




function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div style={{
      maxWidth: 1040,
      minwidth: 940,
      margin: "64px auto",
      padding: "52px 40px 56px 40px",
      background: "#fff",
      borderRadius: 22,
      boxShadow: "0 8px 35px #b3def229",
      fontFamily: '"Inter", "Segoe UI", Arial, sans-serif'
    }}>
      <h1 style={{
        fontWeight: 900,
        color: "#1786c7",
        fontSize: 38,
        marginBottom: 36,
        letterSpacing: ".012em"
      }}>
        {t('legal.privacy_title')}
      </h1>
      <div style={{
        fontSize: "clamp(16px, 1.4vw, 20px)",
        color: "#222d47",
        fontWeight: 400,
        lineHeight: 1.68,
        marginBottom: 19,
        maxWidth: 940
      }}>
        <span dangerouslySetInnerHTML={{ __html: t('legal.privacy_intro')}} />
        <ul>
          <li dangerouslySetInnerHTML={{ __html: t('legal.privacy_data_minimal') }} />
          <li dangerouslySetInnerHTML={{ __html: t('legal.privacy_payment') }} />
          <li dangerouslySetInnerHTML={{ __html: t('legal.privacy_sharing') }} />
          <li dangerouslySetInnerHTML={{ __html: t('legal.privacy_security') }} />
          <li dangerouslySetInnerHTML={{ __html: t('legal.privacy_auditing') }} />
          <li dangerouslySetInnerHTML={{ __html: t('legal.privacy_rights') }} />
          <li dangerouslySetInnerHTML={{ __html: t('legal.privacy_rights2') }} />
        </ul>
         <span dangerouslySetInnerHTML={{ __html: t('legal.privacy_accept')}} />
      </div>
    </div>
  );
}


function ContactInfo() {
  const { t } = useTranslation();
  return (
    <div style={{
      maxWidth: 1040,
      minwidth: 940,
      margin: "84px auto",
      padding: "44px 32px",
      background: "#fff",
      borderRadius: 18,
      boxShadow: "0 8px 35px #b3def229",
      fontFamily: '"Inter", "Segoe UI", Arial, sans-serif'
    }}>
      <h1 style={{
        fontWeight: 900,
        color: "#1786c7",
        fontSize: 32,
        marginBottom: 25,
        letterSpacing: ".012em"
      }}>
        <span dangerouslySetInnerHTML={{ __html: t('legal.contact_info')}} /><br></br><br></br>
      </h1>
      <div style={{
        fontSize: "clamp(17px, 1.4vw, 21px)",
        fontWeight: 400,
        color: "#222d47",
        lineHeight: 1.68,
        marginBottom: 19
      }}>
        <span dangerouslySetInnerHTML={{ __html: t('legal.contact_company')}} /><br></br>
        <span dangerouslySetInnerHTML={{ __html: t('legal.contact_identification_code')}} /><br></br>
        <span dangerouslySetInnerHTML={{ __html: t('legal.contact_location')}} /><br></br>
        <span dangerouslySetInnerHTML={{ __html: t('legal.contact_email')}} /><br></br>
        <span dangerouslySetInnerHTML={{ __html: t('legal.contact_phone')}} />

      </div>
    </div>
  );
}



function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;

  return (
    <div style={{
      marginLeft: 18,
      display: "flex",
      gap: 10,
      alignItems: "center",
      fontFamily: '"Inter", "Segoe UI", Arial, sans-serif'
    }}>
      <button
        onClick={() => i18n.changeLanguage('ka')}
        style={{
          padding: "7px 19px",
          borderRadius: 18,
          fontWeight: 700,
          fontSize: 16,
          color: currentLang === "ka" ? "#fff" : "#1786c7",
          background: currentLang === "ka"
            ? "linear-gradient(90deg,#3bc7fa,#1786c7 85%)"
            : "#f7fbff",
          border: currentLang === "ka"
            ? "none"
            : "2px solid #1786c7",
          boxShadow: currentLang === "ka"
            ? "0 2px 12px #39aed947"
            : "none",
          transition: "background .18s, color .15s, box-shadow .19s",
          cursor: "pointer"
        }}
      >
        ქარ
      </button>
      <button
        onClick={() => i18n.changeLanguage('en')}
        style={{
          padding: "7px 19px",
          borderRadius: 18,
          fontWeight: 700,
          fontSize: 16,
          color: currentLang === "en" ? "#fff" : "#1786c7",
          background: currentLang === "en"
            ? "linear-gradient(90deg,#3bc7fa,#1786c7 85%)"
            : "#f7fbff",
          border: currentLang === "en"
            ? "none"
            : "2px solid #1786c7",
          boxShadow: currentLang === "en"
            ? "0 2px 12px #39aed947"
            : "none",
          transition: "background .18s, color .15s, box-shadow .19s",
          cursor: "pointer"
        }}
      >
        EN
      </button>
    </div>
  );
}


// Simple stub pages





function Landing() {
  const { t } = useTranslation();
  const features = t("landing.features", { returnObjects: true });
  const featuresTitle = t("landing.featuresTitle");

  // Download button (blue) shine
  function shineDownload(e) {
    e.target.style.background =
      "linear-gradient(90deg, #48c1fa 45%, #bbf2ff 100%)";
    e.target.style.boxShadow = "0 4px 20px #42e3ff55";
  }
  function resetDownload(e) {
    e.target.style.background = "#47b2e4";
    e.target.style.boxShadow = "0 3px 12px #47b2e433";
  }

  // Login button (white) shine
  function shineLogin(e) {
    e.target.style.background = "#fff";
    e.target.style.color = "#47b2e4";
    e.target.style.boxShadow = "0 2px 10px #9be4ff66";
    e.target.style.borderColor = "#47b2e4";
  }
  function resetLogin(e) {
    e.target.style.background = "rgba(255,255,255,.18)";
    e.target.style.color = "#fff";
    e.target.style.boxShadow = "none";
    e.target.style.borderColor = "#fff";
  }

  return (
    <>
      {/* HERO */}
      <section
        className="landing-hero"
        style={{
          minHeight: "66vh",
          width: "100%",
          background: "linear-gradient(120deg, #37517e 60%, #45b7fa 130%)",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <div
          className="landing-hero-inner"
          style={{
            maxWidth: 1200,
            width: "95vw",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            zIndex: 2,
            padding: "0 30px",
          }}
        >
          {/* Left / Main Hero */}
          <div
            className="landing-hero-left"
            style={{ flex: 1, color: "#fff", paddingRight: 34 }}
          >
            <h1
              className="landing-hero-title"
              style={{
                fontWeight: 800,
                fontSize: 78,
                lineHeight: 1.2,
                marginBottom: 20,
                background: "linear-gradient(92deg,#45b7fa 0%,#fff 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                textFillColor: "transparent",
              }}
            >
              RealAgentApp
            </h1>
            <h3
              className="landing-hero-subtitle"
              style={{ marginLeft: 10 }}
            >
              {t("your_upload_app")}
            </h3>

            <div
              className="landing-hero-buttons"
              style={{ display: "flex", gap: 17 }}
            >
              <a
                href="https://chrome.google.com/webstore/detail/iagogifkellfdoedoapohhkdlpiggima"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <button
                  className="landing-hero-primary-btn"
                  style={{
                    background: "#47b2e4",
                    color: "#fff",
                    border: "none",
                    borderRadius: 32,
                    fontWeight: 700,
                    fontSize: 20,
                    padding: "15px 0px",
                    minWidth: 200,
                    cursor: "pointer",
                    boxShadow: "0 3px 12px #47b2e433",
                    transition:
                      "background .18s, color .18s, box-shadow .19s",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  onMouseEnter={shineDownload}
                  onMouseLeave={resetDownload}
                >
                  {t("landing.download")}
                </button>
              </a>

              <Link to="/login">
                <button
                  className="landing-hero-secondary-btn"
                  style={{
                    background: "rgba(255,255,255,.18)",
                    color: "#fff",
                    border: "2px solid #fff",
                    borderRadius: 32,
                    fontWeight: 700,
                    fontSize: 20,
                    padding: "15px 0px",
                    minWidth: 200,
                    cursor: "pointer",
                    transition:
                      "background .18s, color .18s, border-color .18s, box-shadow .16s",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  onMouseEnter={shineLogin}
                  onMouseLeave={resetLogin}
                >
                  {t("landing.login")}
                </button>
              </Link>
            </div>
          </div>

          {/* Right Section (hidden on mobile) */}
          <div
            className="landing-hero-right"
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        </div>
      </section>

      {/* FEATURES */}
      <section
        style={{
          width: "100%",
          background:
            "linear-gradient(110deg, #f6fbff 80%, #e7f5fc 100%)",
          padding: "18px 0 118px 0",
          margin: 0,
          minHeight: "670px",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: 110,
            height: 8,
            borderRadius: 8,
            background: "linear-gradient(90deg,#39AED9,#45b7fa 90%)",
            margin: "0 auto 52px auto",
          }}
        />
        <h2
          style={{
            textAlign: "center",
            fontSize: 42,
            fontWeight: 900,
            color: "#17548a",
            marginBottom: 58,
            letterSpacing: ".021em",
          }}
        >
          {featuresTitle}
        </h2>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "39px",
            justifyContent: "flex-start",
            alignItems: "center",
            width: "100%",
            maxWidth: 820,
            margin: "0 auto",
          }}
        >
          {features.map((feature, idx) => (
            <div
              key={idx}
              style={{
                width: "100%",
                background:
                  "linear-gradient(92deg,#e9f8fc 90%,#fff 100%)",
                boxShadow: "0 1.7px 13px #47b2e41c",
                borderRadius: 18,
                padding: "33px 27px",
                margin: 0,
                fontSize: 22.5,
                color: "#185486",
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                gap: "29px",
                transition: "box-shadow .17s",
              }}
            >
              <span
                style={{
                  minWidth: 45,
                  minHeight: 45,
                  borderRadius: "50%",
                  background:
                    "linear-gradient(120deg,#39aed9 57%,#45b7fa 101%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginRight: 7,
                  boxShadow: "0 2.2px 14px #39aed924",
                }}
              >
                <svg width="27" height="27" viewBox="0 0 23 23">
                  <circle cx="11.5" cy="11.5" r="11.5" fill="none" />
                  <path
                    d="M7 12.7l3.1 3.1 5.6-5.8"
                    stroke="#fff"
                    strokeWidth="2.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span>{feature}</span>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}




const plans = [
  {
    label: "daily",
    price: "1.5 GEL",
    period: "/day",
    summary: "Pay-as-you-go. Try real automation for a day.",
    cta: "Buy 1 Day",
    color: "#39AED9"
  },
  {
    label: "weekly",
    price: "8 GEL",
    period: "/week",
    summary: "Short commitment, flexible savings.",
    cta: "Buy 1 Week",
    color: "#7ad1f6"
  },
  {
    label: "monthly",
    price: "20 GEL",
    period: "/month",
    summary: "Most popular: continuous access, highest value.",
    cta: "Subscribe 1 Month",
    color: "#fbc442",
    badge: "Most Popular"
  },
  {
    label: "6months",
    price: "80 GEL",
    period: "/6 mo",
    summary: "Lowest price per day. For power users.",
    cta: "Subscribe 6 Months",
    color: "#D4AF37",
    badge: "Best Value"
  }
];

function Pricing({ userData }) {
  const [confirmMsg, setConfirmMsg] = useState('');
  const confirmMsgTimeout = useRef(null);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [pendingPlan, setPendingPlan] = useState(null);
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const pricingTitle = t('pricing.title');
  const [selectedLabel, setSelectedLabel] = useState(null);

  // Subscription warning popup
  const [showSubWarning, setShowSubWarning] = useState(false);
  const [subWarningText, setSubWarningText] = useState('');
  const [showPlanConfirm, setShowPlanConfirm] = useState(false);
  const [planToConfirm, setPlanToConfirm] = useState(null);

    // Pricing overrides from Firestore
  const [pricingMode, setPricingMode] = useState("standard"); 
  // "standard" | "globalPromo" | "specialUser"
  const [effectivePlans, setEffectivePlans] = useState(plans);
  const [pricingLoaded, setPricingLoaded] = useState(false);
  const [promoMonth, setPromoMonth] = useState("");
const location = useLocation();
const [pendingExtEmail, setPendingExtEmail] = useState('');

useEffect(() => {
  const params = new URLSearchParams(location.search);
  const extEmailParam = params.get('extEmail');
  if (extEmailParam) {
    setPendingExtEmail(decodeURIComponent(extEmailParam));
  }
}, [location.search]);

const [showEmailMismatchModal, setShowEmailMismatchModal] = useState(false);
const [emailMismatch, setEmailMismatch] = useState(null);


useEffect(() => {
  const params = new URLSearchParams(location.search);
  const extEmailParam = params.get('extEmail');
  if (!extEmailParam) return;

  const extEmail = decodeURIComponent(extEmailParam);

  if (!user) {
    // Not logged in → show login modal with email prefilled
    setPendingExtEmail(extEmail);
    setShowLoginModal(true);
    return;
  }

  if (user.email && user.email.toLowerCase() !== extEmail.toLowerCase()) {
    // Logged in as someone else → ask to switch
    setEmailMismatch({
      extensionEmail: extEmail,
      siteEmail: user.email,
    });
    setShowEmailMismatchModal(true);
  }
}, [user, location.search]);

  
useEffect(() => {
  let cancelled = false;

  const fetchPricingConfig = async () => {
    try {
      const globalRef = doc(db, "pricingConfig", "globalDiscount");
      const specialRef = doc(db, "pricingConfig", "specialUsers");

      const [globalSnap, specialSnap] = await Promise.all([
        getDoc(globalRef),
        getDoc(specialRef),
      ]);

      console.log("🔵 globalSnap.exists:", globalSnap.exists());
      console.log("🔵 specialSnap.exists:", specialSnap.exists());

      const now = Date.now();
      let mode = "standard";
      let modifiedPlans = [...plans];

      // 1) Special user pricing NOW HAS ABSOLUTE PRIORITY
      if (specialSnap.exists()) {
        const s = specialSnap.data();
        const myEmail = (user?.email || "").toLowerCase().trim();

        // 1a) Personal price (customPrices) — same rule as the payment server
        const personal = (Array.isArray(s.customPrices) ? s.customPrices : [])
          .find(p => p && typeof p.email === "string" && p.email.toLowerCase().trim() === myEmail);

        // 1b) Shared special price (emails + specialMonthlyPrice)
        const emails = (s.emails || []).map(e => String(e).toLowerCase().trim());
        const specialPrice = s.specialMonthlyPrice;

        let myPrice = null;
        if (myEmail && personal && typeof personal.price === "number" && personal.price > 0) {
          myPrice = personal.price;
        } else if (myEmail && emails.includes(myEmail) && typeof specialPrice === "number") {
          myPrice = specialPrice;
        }

        if (myPrice !== null) {
          mode = "specialUser";
          modifiedPlans = plans.map((p) =>
            p.label === "monthly"
              ? {
                  ...p,
                  price: `${myPrice} GEL`,
                  summary: "Special monthly price available for your account.",
                  cta: "Subscribe 1 Month (Special)",
                  badge: "Special Price",
                }
              : p
          );
        }
      }

      // 2) If NO special user pricing was applied, check for Global Promo
      if (mode === "standard" && globalSnap.exists()) {
        const g = globalSnap.data();
        const active = g.monthlyPromoActive;
        const start = g.monthlyPromoStart?.toMillis?.() ?? 0;
        const end = g.monthlyPromoEnd?.toMillis?.() ?? 0;

        const promoMonthEn = g.promoMonthEn || "";
        const promoMonthKa = g.promoMonthKa || "";

        if (
          active &&
          now >= start &&
          now <= end &&
          typeof g.promoMonthlyPrice === "number"
        ) {
          mode = "globalPromo";
          const promoPriceGel = g.promoMonthlyPrice;

          const lang = i18n.language;
          const monthLabel = lang === "ka" ? promoMonthKa : promoMonthEn;

          modifiedPlans = plans.map((p) =>
            p.label === "monthly"
              ? {
                  ...p,
                  originalPrice: "20 GEL",
                  price: `${promoPriceGel} GEL`,
                  summary: "Limited-time 50% discount for this month only.",
                  cta: "Subscribe 1 Month (Promo)",
                  badge: "50% OFF",
                  promoNote: "Valid only for this month.",
                }
              : p
          );

          if (!cancelled) {
            setPromoMonth(monthLabel);
          }
        }
      }

      // 3) Finalize state
      if (!cancelled) {
        console.log(
          "✅ final pricing mode:",
          mode,
          "monthly:",
          modifiedPlans.find((p) => p.label === "monthly")
        );
        setPricingMode(mode);
        setEffectivePlans(modifiedPlans);
        setPricingLoaded(true);
      }
    } catch (err) {
      console.error("Error loading pricing config:", err);
    }
  };

  fetchPricingConfig();
  return () => {
    cancelled = true;
  };
}, [user, i18n.language]);



  // ✅ HANDLE PLAN PURCHASE - Create order on Flitt
  const handlePlanPurchase = async (planLabel) => {
    console.log(`🟦 handlePlanPurchase called with plan: ${planLabel}`);

    if (!user) {
      console.log('No user, showing login modal');
      setShowLoginModal(true);
      setPendingPlan(planLabel);
      return;
    }

    try {
      console.log(`📱 Creating order for user: ${user.uid}, plan: ${planLabel}`);

      // ✅ SAVE TO localStorage (fallback if redirect doesn't have order_id)
      localStorage.setItem('lastFlittOrderId', '');
      localStorage.setItem('lastFlittPlanType', planLabel);

      // Inside handlePlanPurchase
      const idToken = await user.getIdToken(true); // Get secure session token
      
      const response = await fetch(
        'https://payment-server-8ima.onrender.com/api/create-flitt-order',
        {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}` // <-- Pass token in headers securely
          },
          body: JSON.stringify({
            planType: planLabel
            // Note: No need to send userId anymore!
          }),
        }
      );

      const data = await response.json();
      console.log('🔵 Backend response:', data);

      // ✅ Backend returns 'url', not 'checkoutUrl'
      const checkoutUrl = data.url || data.checkoutUrl;
      const orderId = data.order_id || data.orderId;

      if (checkoutUrl) {
        // ✅ SAVE order_id to localStorage
        localStorage.setItem('lastFlittOrderId', orderId);
        localStorage.setItem('lastFlittPlanType', planLabel);

        console.log(`✅ Redirecting to Flitt checkout: ${checkoutUrl}`);
        // ✅ REDIRECT TO FLITT PAYMENT PAGE
        window.location.href = checkoutUrl;
      } else {
        console.error('❌ No checkout URL returned:', data);
        alert('Failed to create order. Please try again.');
      }
    } catch (error) {
      console.error('❌ Error creating order:', error);
      alert('Error creating order: ' + error.message);
    }
  };

// You will need your extension's official ID from the Chrome Web Store
  // (Or your local developer ID if testing locally)
  // const EXTENSION_ID = "iagogifkellfdoedoapohhkdlpiggima"; 
  const EXTENSION_ID = "icioidclkdpinaimlkjjnoomeggamefp"; 

  function handlePlanClick(planLabel) {
    setSelectedLabel(planLabel);
    const planObj = effectivePlans.find((p) => p.label === planLabel) || plans.find((p) => p.label === planLabel);
    const msg = planObj ? `${planObj.price} ${planObj.period}` : planLabel;
    setConfirmMsg(`Chosen: ${msg}`);
    clearTimeout(confirmMsgTimeout.current);
    confirmMsgTimeout.current = setTimeout(() => setConfirmMsg(''), 2500);
    setTimeout(() => setSelectedLabel(null), 3000);

    // 1. If not logged into the website, show login modal
    if (!user) {
      setPendingPlan(planLabel);
      setShowLoginModal(true);
      return;
    }

    // 2. 🛡️ THE GUARDRAIL: Ping the extension before allowing payment
    if (window.chrome && window.chrome.runtime && window.chrome.runtime.sendMessage) {
      window.chrome.runtime.sendMessage(EXTENSION_ID, { action: "GET_EXTENSION_USER" }, (response) => {
        // If extension responded, and has an email, and it doesn't match the website email
        if (response && response.email && response.email.toLowerCase() !== user.email.toLowerCase()) {
          console.warn("Session Mismatch Detected!", response.email, "vs", user.email);
          setEmailMismatch({
            extensionEmail: response.email,
            siteEmail: user.email,
          });
          setShowEmailMismatchModal(true);
          return; // STOP the purchase flow
        } else {
          // Emails match (or extension isn't installed/logged in), proceed normally
          proceedToConfirmation(planLabel, planObj);
        }
      });
    } else {
      // Not in Chrome or extension can't be reached, proceed normally
      proceedToConfirmation(planLabel, planObj);
    }
  }

  // Helper function to continue the flow if the check passes
  function proceedToConfirmation(planLabel, planObj) {
    if (userData?.subscriptionActive && userData?.planExpiry) {
      const now = Date.now();
      if (userData.planExpiry > now) {
        const expiryText = new Date(userData.planExpiry).toLocaleDateString();
        setSubWarningText(t('pricing.subscription.active_body', { date: expiryText }));
        setShowSubWarning(true);
        return;
      }
    }
    setPlanToConfirm({
      label: planLabel,
      price: planObj?.price,
      period: planObj?.period,
    });
    setShowPlanConfirm(true);
  }



 // ✅ JSX RETURN - PRICING CARDS + MODALS
  return (
    <>
      <div
        style={{
          minHeight: '80vh',
          padding: '64px 0',
          background: 'linear-gradient(130deg, #f8fafc 67%, #edf1f6 100%)',
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: '0 auto',
            padding: '0 16px',
          }}
        >
          <h1
            style={{
              textAlign: 'center',
              color: '#23263a',
              fontSize: 48,
              fontWeight: 800,
              marginBottom: 44,
              letterSpacing: '.02em',
            }}
          >
            {pricingTitle}
          </h1>  
       {pricingLoaded && pricingMode === "globalPromo" && (
  <p
    style={{
      textAlign: 'center',
      color: '#1786c7',
      marginTop: -20,
      marginBottom: 24,
      fontWeight: 600,
    }}
  >
    {t('pricing.globalPromoBanner', { month: promoMonth })}
  </p>
)}


          {pricingLoaded && pricingMode === "specialUser" && (
            <p
              style={{
                textAlign: 'center',
                color: '#1786c7',
                marginTop: -20,
                marginBottom: 24,
                fontWeight: 600,
              }}
            >
                  {t('pricing.specialUserBanner')}
            </p>
          )}

          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '32px',
              justifyContent: 'center',
            }}
          >
            {effectivePlans.map((plan) => (

              <div
                key={plan.label}
                onClick={() => handlePlanClick(plan.label)}
                style={{
                  flex: '1 1 230px',
                  minWidth: 220,
                  maxWidth: 270,
                  background: '#fff',
                  borderRadius: 22,
                  boxShadow: '0 6px 30px #c2d1eb23',
                  border:
                    selectedLabel === plan.label
                      ? '3px solid #37b24d'
                      : plan.badge
                      ? `2.3px solid ${plan.color}`
                      : '2px solid rgba(130,150,180,0.13)',
                  padding: '38px 30px 32px 30px',
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  cursor: 'pointer',
                  transition: 'transform .14s, box-shadow .14s',
                  userSelect: 'none',
                  outline: 'none',
                  ...(plan.badge
                    ? { boxShadow: `0 0 0 4px ${plan.color}26` }
                    : {}),
                }}
                tabIndex={0}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') handlePlanClick(plan.label);
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform =
                    'translateY(-6px) scale(1.04)';
                  e.currentTarget.style.boxShadow = '0 8px 46px #b3bfd621';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = '';
                  e.currentTarget.style.boxShadow = plan.badge
                    ? `0 0 0 4px ${plan.color}26`
                    : '0 6px 30px #c2d1eb23';
                }}
              >
                {plan.badge && (
                  <span
                    style={{
                      position: 'absolute',
                      top: 8,
                      left: '50%',
                      transform: 'translateX(-50%)',
                      background: plan.color,
                      color: '#201c0f',
                      fontWeight: 700,
                      fontSize: 13,
                      padding: '5px 17px',
                      borderRadius: 12,
                      letterSpacing: '.015em',
                      boxShadow: '0 2px 7px #fff3',
                    }}
                  >
                    {plan.badge}
                  </span>
                )}
                          <div
                  style={{
                    color: plan.color,
                    fontWeight: 900,
                    fontSize: 32,
                    letterSpacing: '.01em',
                    marginBottom: 2,
                    marginTop: 18,           
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 6,
                  }}
                >
                  {plan.originalPrice && (
                    <div
                      style={{
                        fontSize: 17,
                        color: '#7b91b4',
                        textDecoration: 'line-through',
                      }}
                    >
                      {plan.originalPrice} /month
                    </div>
                  )}

                  <div>
                    {plan.price}
                    <span
                      style={{
                        fontSize: 17,
                        fontWeight: 400,
                        color: '#7b91b4',
                        marginLeft: 4,
                      }}
                    >
                      {plan.period}
                    </span>
                  </div>
                </div>

                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 'clamp(14px,1.8vw,22px)',
                    margin: '17px 0 9px 0',
                    letterSpacing: '.01em',
                    color: '#23263a',
                    width: '100%',
                    textAlign: 'center',
                  }}
                >
                  {t(`pricing.labels.${plan.label}`)}
                </div>
                <div
                  style={{
                    color: '#435579',
                    fontSize: 'clamp(13px,1.4vw,16.5px)',
                    minHeight: 40,
                    marginBottom: 22,
                    marginTop: 2,
                    width: '100%',
                    textAlign: 'center',
                  }}
                >
                  {t(`pricing.summaries.${plan.label}`)}
                </div>
                <div
                  style={{
                    padding: '12px 22px',
                    width: '80%',
                    fontWeight: 700,
                    fontSize: 'clamp(13px,1.2vw,16.5px)',
                    textAlign: 'center',
                    background: `linear-gradient(98deg, ${plan.color} 60%,#ffffff 100%)`,
                    color: '#232633',
                    border: 'none',
                    borderRadius: 8,
                    boxShadow: `0 2px 11px ${plan.color}11`,
                    letterSpacing: '.01em',
                    marginTop: 'auto',
                    pointerEvents: 'none',
                  }}
                >
                  {t(`pricing.ctas.${plan.label}`)}
                </div>
              </div>
            ))}
          </div>
          {confirmMsg && (
            <div
              style={{
                color: '#37b24d',
                fontWeight: 700,
                margin: '32px auto',
                textAlign: 'center',
                fontSize: '17px',
                background: '#eafbee',
                borderRadius: 9,
                padding: '9px 27px',
                display: 'inline-block',
                boxShadow: '0 3px 14px #2bbd6f11',
              }}
            >
              {confirmMsg}
            </div>
          )}
        </div>

 {/* Login Modal */}
        {showLoginModal && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              background: 'rgba(30,40,60,0.30)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 2000,
            }}
          >
            <div
              style={{
                background: '#fff',
                borderRadius: 18,
                padding: '40px 36px',
                boxShadow: '0 8px 32px #b3def233',
                minWidth: 340,
                textAlign: 'center',
              }}
            >
              <h2 style={{ color: '#39AED9', marginBottom: 18 }}>
                Log in Required
              </h2>
              <p
                style={{
                  color: '#23263a',
                  fontWeight: 500,
                  marginBottom: 18,
                }}
              >
                You need to log in to purchase a subscription plan.
                <br />
                This ensures your subscription is linked to your account.
              </p>
              <button
                onClick={() => {
                  setShowLoginModal(false);
                  const params = new URLSearchParams(window.location.search);
                  const extEmailParam = params.get('extEmail');
                  if (extEmailParam) {
                    navigate(
                      `/login?extEmail=${encodeURIComponent(extEmailParam)}`
                    );
                  } else {
                    navigate('/login');
                  }
                }}
                style={{
                  background:
                    'linear-gradient(90deg,#39AED9 60%,#1786c7 100%)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: 7,
                  padding: '12px 32px',
                  fontWeight: 700,
                  fontSize: 17,
                  cursor: 'pointer',
                }}
              >
                Go to Login
              </button>
              <div>
                <button
                  onClick={() => setShowLoginModal(false)}
                  style={{
                    marginTop: 18,
                    background: 'none',
                    border: 'none',
                    color: '#888',
                    textDecoration: 'underline',
                    fontSize: 15,
                    cursor: 'pointer',
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Subscription already active modal */}
    {showSubWarning && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(10,20,40,0.45)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 2100,
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 18,
            padding: "32px 30px 26px 30px",
            boxShadow: "0 10px 40px rgba(0,0,0,0.18)",
            maxWidth: 420,
            textAlign: "center",
          }}
        >
          <div style={{ fontSize: 40, marginBottom: 10 }}>✅</div>
          <h2 style={{ color: "#37b24d", marginBottom: 12 }}>
          {t("pricing.subscription.active_title")}
          </h2>
          <p
            style={{
              color: "#333",
              fontSize: 15.5,
              lineHeight: 1.5,
              marginBottom: 18,
              whiteSpace: "pre-line",
            }}
          >
            {subWarningText}
          </p>
          <button
            onClick={() => setShowSubWarning(false)}
            style={{
              background: "linear-gradient(90deg,#39AED9 60%,#1786c7 100%)",
              color: "#fff",
              border: "none",
              borderRadius: 7,
              padding: "10px 26px",
              fontWeight: 700,
              fontSize: 15,
              cursor: "pointer",
            }}
          >
              {t("pricing.subscription.active_button")}
          </button>
        </div>
      </div>
    )}

{showEmailMismatchModal && emailMismatch && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(15, 23, 42, 0.7)',
      backdropFilter: 'blur(5px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 3000,
      animation: 'fadeIn 0.2s ease-out',
    }}
  >
    <div
      style={{
        background: '#fff',
        borderRadius: 24,
        padding: '36px',
        boxShadow: '0 24px 60px rgba(0,0,0,0.3)',
        maxWidth: 520,
        width: '90vw',
        textAlign: 'center',
        position: 'relative',
        fontFamily: '"Inter", "Segoe UI", Arial, sans-serif',
      }}
    >
      {/* Warning Icon Banner */}
      <div
        style={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%)',
          color: '#e11d48',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px auto',
          fontSize: 34,
          boxShadow: '0 4px 14px rgba(225, 29, 72, 0.15)',
        }}
      >
        ⚠️
      </div>

      <h2
        style={{
          color: '#0f172a',
          margin: '0 0 14px 0',
          fontSize: 26,
          fontWeight: 800,
          letterSpacing: '-0.02em',
        }}
      >
        {t('pricing.mismatch.title')}
      </h2>

      <p
        style={{
          color: '#475569',
          fontSize: 16,
          lineHeight: 1.6,
          margin: '0 0 24px 0',
        }}
      >
        {t('pricing.mismatch.desc1')}
        <strong style={{ color: '#1786c7' }}>{emailMismatch.extensionEmail}</strong>
        {t('pricing.mismatch.desc2')}
        <strong style={{ color: '#1786c7' }}>{emailMismatch.siteEmail}</strong>.
      </p>

      <div
        style={{
          background: '#f8fafc',
          borderRadius: 14,
          padding: '16px 20px',
          marginBottom: 28,
          border: '1px dashed #cbd5e1',
        }}
      >
        <p
          style={{
            margin: 0,
            fontSize: 14.5,
            color: '#334155',
            fontWeight: 600,
            lineHeight: 1.5,
          }}
        >
          {t('pricing.mismatch.warning')}
        </p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <button
          onClick={async () => {
            // 1. Force log out the current incorrect website user
            await auth.signOut();
            // 2. Hide this modal
            setShowEmailMismatchModal(false);
            // 3. Send them to the login page with the extension's email pre-filled!
            navigate(`/login?extEmail=${encodeURIComponent(emailMismatch.extensionEmail)}`);
          }}
          style={{
            background: 'linear-gradient(90deg, #39AED9 0%, #1786c7 100%)',
            color: '#fff',
            border: 'none',
            padding: '16px 24px',
            borderRadius: 14,
            fontSize: 16,
            fontWeight: 700,
            cursor: 'pointer',
            boxShadow: '0 4px 14px rgba(23, 134, 199, 0.3)',
            transition: 'transform 0.2s, box-shadow 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(23, 134, 199, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 14px rgba(23, 134, 199, 0.3)';
          }}
        >
          {t('pricing.mismatch.switch')} {emailMismatch.extensionEmail}
        </button>

        <button
          onClick={() => {
            // If they choose to keep using the current site email, 
            // just close the modal and let them continue normally.
            setShowEmailMismatchModal(false);
          }}
          style={{
            background: '#fff',
            color: '#64748b',
            border: '2px solid #e2e8f0',
            padding: '15px 24px',
            borderRadius: 14,
            fontSize: 16,
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'all 0.2s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#f8fafc';
            e.currentTarget.style.color = '#0f172a';
            e.currentTarget.style.borderColor = '#cbd5e1';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#fff';
            e.currentTarget.style.color = '#64748b';
            e.currentTarget.style.borderColor = '#e2e8f0';
          }}
        >
          {t('pricing.mismatch.keep')} {emailMismatch.siteEmail}
        </button>
      </div>
    </div>
  </div>
)}

      {/* Plan confirmation modal */}
{showPlanConfirm && planToConfirm && (
  <div
    onClick={() => {
      setShowPlanConfirm(false);
      setPlanToConfirm(null);
    }}
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(10,20,40,0.45)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 2200,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
      style={{
        background: '#fff',
        borderRadius: 22,
        padding: '28px 34px 30px 34px',
        boxShadow: '0 12px 46px rgba(0,0,0,0.22)',
        maxWidth: 520,
        width: '92vw',
        textAlign: 'left',
        fontFamily:
          'Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
        position: 'relative',
      }}
    >
      {/* X close button */}
      <button
        onClick={() => {
          setShowPlanConfirm(false);
          setPlanToConfirm(null);
        }}
        style={{
          position: 'absolute',
          top: 12,
          right: 14,
          background: 'none',
          border: 'none',
          fontSize: 22,
          fontWeight: 600,
          color: '#9aa4b5',
          cursor: 'pointer',
          lineHeight: 1,
        }}
        aria-label="Close"
      >
        ×
      </button>

      <h2
        style={{
          color: '#1786c7',
          marginBottom: 18,
          fontSize: 24,
          fontWeight: 800,
        }}
      >
        {t('pricing.confirm_title', 'Confirm your purchase')}
      </h2>

      {/* Big email + plan line */}
      <div
        style={{
          borderRadius: 14,
          background: 'linear-gradient(96deg,#f3f8ff,#e6f3ff)',
          padding: '14px 16px',
          marginBottom: 16,
        }}
      >
        {user?.email && (
          <div
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: '#4b5b76',
              marginBottom: 6,
            }}
          >
            {t('pricing.confirm_email_label', 'Account')}
          </div>
        )}

        {user?.email && (
          <div
            style={{
              fontSize: 18,
              fontWeight: 800,
              color: '#1b2a41',
              wordBreak: 'break-all',
            }}
          >
            {user.email}
          </div>
        )}

        <div
          style={{
            marginTop: user?.email ? 10 : 0,
            fontSize: 15,
            fontWeight: 600,
            color: '#4b5b76',
            marginBottom: 4,
          }}
        >
          {t('pricing.confirm_plan_label', 'Selected plan')}
        </div>
        <div
          style={{
            fontSize: 19,
            fontWeight: 800,
            color: '#1786c7',
          }}
        >
          {t('pricing.labels.' + planToConfirm.label)} · {planToConfirm.price}{' '}
          {planToConfirm.period}
        </div>
      </div>

      <p
        style={{
          color: '#475569',
          fontSize: 14.8,
          lineHeight: 1.6,
          marginBottom: 20,
        }}
      >
        {user?.email
          ? t(
              'pricing.confirm_body_loggedin',
              'You are about to purchase a subscription for this account.'
            )
          : t(
              'pricing.confirm_body_nologin',
              'You are about to purchase a subscription.'
            )}
        <br />
        {t(
          'pricing.confirm_note',
          'Please review the email and plan before proceeding.'
        )}
      </p>

      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 10,
          marginTop: 4,
        }}
      >
        <button
          onClick={() => {
            setShowPlanConfirm(false);
            setPlanToConfirm(null);
          }}
          style={{
            background: 'none',
            border: 'none',
            color: '#6b7280',
            fontSize: 14,
            fontWeight: 600,
            cursor: 'pointer',
            padding: '8px 10px',
          }}
        >
          {t('pricing.cancel_button', 'Cancel')}
        </button>

        <button
          onClick={() => {
            setShowPlanConfirm(false);
            handlePlanPurchase(planToConfirm.label);
          }}
          style={{
            background:
              'linear-gradient(90deg,#39AED9 60%,#1786c7 100%)',
            color: '#fff',
            border: 'none',
            borderRadius: 9,
            padding: '12px 30px',
            fontWeight: 750,
            fontSize: 16,
            cursor: 'pointer',
            minWidth: 150,
            boxShadow: '0 3px 14px rgba(55,160,215,0.35)',
          }}
        >
          {t('pricing.confirm_button', 'Proceed to payment')}
        </button>
      </div>
    </div>
  </div>
)}

  </>
);
}

// Utility: Array of instructions, with (optional) image for each
const instructionSteps = [
  {
    title: "Log in or register",
    description: "Create your account or log in for a secure, personalized experience.",
    image: "/images/step1-login.png"
  },
  {
    title: "Install the browser extension",
    description: "Click download and add RealAgentApp to Chrome from the official store.",
    image: "/images/step2-install.png"
  },
  {
    title: "Extract real estate data",
    description: "Visit a property listing and activate the extension to auto-extract info.",
    image: "/images/step3-extract.png"
  },
  {
    title: "Track and sync listings",
    description: "Open your dashboard to manage, sync, and export all your listings.",
    image: "/images/step4-dashboard.png"
  }
];


const downloadSteps = [
  {
    title: "Download Extension",
    description: "Go to Chrome Web Store and download RealAgentApp. Make sure you’re signed into your main Chrome profile.",
    image: "/images/step-download.png"
  },
  {
    title: "Register Your Account",
    description: "Registration is required! Enter your working Google email during signup—it must be valid to unlock features like Google Sheets sync.",
    image: "/images/step-register.png"
  },
  {
    title: "Email Verification",
    description: "Check your inbox for a confirmation email. Follow the link to verify your account and enable full app access.",
    image: "/images/step-verify.png"
  },
];

const appUseSteps = [
  {
    title: "Activate Extension",
    description: "Navigate to your desired real estate site. Click the RealAgentApp extension to begin.",
    image: "/images/step-activate.png"
  },
  {
    title: "Extract and Sync",
    description: "Select a listing to extract address, photos, and details. Data will be synced to your dashboard and Google Sheets upon confirmation.",
    image: "/images/step-extract-sync.png"
  },
  {
    title: "Dashboard Actions",
    description: "Your dashboard displays all imported listings. Edit, export, or manage your data right from your account.",
    image: "/images/step-dashboard.png"
  },
  // Add more steps/screenshots as needed!
];

function StylishSteps({ sectionTitle, steps }) {
  return (
    <section style={{
      marginBottom: 52,
      background: "#fff",
      borderRadius: 20,
      boxShadow: "0 6px 38px #b4def326",
      padding: "32px 24px 32px 24px",
      maxWidth: 800,
      marginLeft: "auto",
      marginRight: "auto"
    }}>
      <h2 style={{
        color: "#1981d7",
        fontWeight: 800,
        fontSize: 30,
        marginBottom: 20,
        letterSpacing: ".01em",
      }}>
        {sectionTitle}
      </h2>
      <div style={{
        margin: "0 auto 28px auto",
        width: 62,
        height: 5,
        borderRadius: 5,
        background: "linear-gradient(90deg,#49c0ff,#b6e0fb 90%)",
        opacity: 0.47
      }} />
      {steps.map((step, i) => (
        <div key={i} style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: "center",
          margin: "33px 0",
          borderRadius: 13,
          background: i % 2 === 0
            ? "linear-gradient(90deg,#e9f6fe 78%,#fafdff 100%)"
            : "linear-gradient(90deg,#fafdff 8%,#e9f6fe 100%)",
          boxShadow: "0 2.5px 13px #b4def318",
          padding: "18px 19px 18px 14px",
          gap: 26,
        }}>
          <div style={{ flex: 2, minWidth: 0, display: "flex", flexDirection: "column" }}>
            <div style={{
              color: "#199cdf",
              fontWeight: 700,
              fontSize: 21,
              marginBottom: 7,
              letterSpacing: ".012em"
            }}>
              Step {i + 1}: {step.title}
            </div>
            <div style={{
              color: "#34538e",
              fontSize: 17,
              fontWeight: 500,
              lineHeight: 1.45
            }}>
              {step.description}
            </div>
          </div>
          {step.image &&
            <div style={{
              flex: 1.1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
              <img
                src={step.image}
                alt={`Step ${i + 1}`}
                style={{
                  maxHeight: 135,
                  maxWidth: 170,
                  borderRadius: 8,
                  boxShadow: "0 0 0 3px #e9f8fd, 0 1.5px 6px #b1dfea22"
                }}
              />
            </div>
          }
        </div>
      ))}
    </section>
  );
}





// === 1. YOUR DATA ARRAY (WITH RELIABLE UNSPLASH IMAGES) ===
const instructionsSections = [
  {
    id: "download",
    title: "1. Download & First Launch",
    icon: <Download fontSize="small" />,
    subtitle: "Start from the website, install the extension, and open the main RealAgent window.",
    steps: [
      {
        title: "Open the RealAgent website",
        images: ["https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=800&q=80"],
        body: "Visit the official RealAgent site in your browser. The home page shows the main hero section with a Download Extension button.",
      },
      {
        title: "Go to Chrome Web Store",
        images: ["https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?auto=format&fit=crop&w=800&q=80"],
        body: "Click the Download button to open the Chrome Web Store listing in a new tab. Check that the extension is published by RealAgent before continuing.",
      },
      {
        title: "Install the extension",
        images: ["https://images.unsplash.com/photo-1611162617474-5b21e879e113?auto=format&fit=crop&w=800&q=80"],
        body: "Press Add to Chrome and confirm the browser dialog. After installation, pin the RealAgent icon so you can open it in one click.",
      },
      {
        title: "Open the main extension view",
        images: ["https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80"],
        body: "Click the RealAgent icon in the toolbar. The main window appears with the URL field, upload options, and portal buttons.",
      },
    ],
  },
  {
    id: "registration",
    title: "2. Registration & Payment",
    icon: <Payment fontSize="small" />,
    subtitle: "Create your account, confirm your email, and activate a subscription plan.",
    steps: [
      {
        title: "Create your RealAgent account",
        images: ["https://images.unsplash.com/photo-1555421689-491a97ff2040?auto=format&fit=crop&w=800&q=80"],
        body: "From the website, open the Login page and switch to Sign Up. Enter your email, password, full name, and upload display name, then submit the form.",
      },
      {
        title: "Confirm email verification",
        images: ["https://images.unsplash.com/photo-1584433144859-1fc3ab64a957?auto=format&fit=crop&w=800&q=80"],
        body: "Check your inbox for a RealAgent verification email. Open it and click the confirmation link to fully activate your account.",
      },
      {
        title: "Choose a subscription plan",
        images: ["https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=800&q=80"],
        body: "Navigate to the Pricing section. Review daily, weekly, monthly, and 6‑month plans, then select the option that best matches your usage.",
      },
      {
        title: "Complete secure payment",
        images: ["https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=800&q=80"],
        body: "After selecting a plan, continue to the payment page. Follow the gateway instructions until you see a success message and return link.",
      },
      {
        title: "Check active subscription status",
        images: ["https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80"],
        body: "Open your dashboard. The subscription area shows your active plan type and remaining days so you always know your current status.",
      },
    ],
  },
  {
    id: "main-topbar",
    title: "3. Main Window – Top Bar",
    icon: <Web fontSize="small" />,
    subtitle: "Understand the account, language, and quick‑access controls at the top of the extension.",
    steps: [
      {
        title: "Account avatar and user email",
        images: ["https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=800&q=80"],
        body: "The left side shows your initials and email. Use this area to quickly confirm which account is active while working in multiple profiles.",
      },
      {
        title: "Language switches (EN / KA)",
        images: ["https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80"],
        body: "Toggle between English and Georgian with one click. The entire interface, labels, and prompts update instantly to the active language.",
      },
      {
        title: "Settings entry point",
        images: ["https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=800&q=80"],
        body: "Use the Settings button to open advanced configuration: upload names, custom descriptions, URL options, and subscription details.",
      },
      {
        title: "Logout control",
        images: ["https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?auto=format&fit=crop&w=800&q=80"],
        body: "When you need to switch accounts, use Logout from the top bar. After logging out, your subscription remains linked to the same email.",
      },
    ],
  },
  {
    id: "main-actions",
    title: "4. Main Actions & Google Sheets",
    icon: <TableChart fontSize="small" />,
    subtitle: "Paste listing URLs, select upload modes, and link a Google Sheet for structured exports.",
    steps: [
      {
        title: "Paste the listing URL",
        images: ["https://images.unsplash.com/photo-1432888622747-4eb9a8efeb07?auto=format&fit=crop&w=800&q=80"],
        body: "Copy the ad URL from your real estate portal and paste it into the main URL field. This tells RealAgent which listing you are working on.",
      },
      {
        title: "Choose upload type",
        images: ["https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80"],
        body: "Select whether this job is a standard upload, a Google Sheet export, or a changed‑price update. The extension adapts prompts to your choice.",
      },
      {
        title: "Pick the portal mode",
        images: ["https://images.unsplash.com/photo-1507238692062-5a042c5b3934?auto=format&fit=crop&w=800&q=80"],
        body: "Use the Myhome, SS, or Myhome + SS buttons to control which portals RealAgent targets. Combined mode is ideal when you mirror listings.",
      },
      {
        title: "Link a Google Sheet",
        images: ["https://images.unsplash.com/photo-1543286386-713bcd534007?auto=format&fit=crop&w=800&q=80"],
        body: "In Sheet mode, provide your Google Sheet link or ID. RealAgent validates access before saving the connection for upcoming exports.",
      },
      {
        title: "Export data to your Sheet",
        images: ["https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=800&q=80"],
        body: "After extracting listing details, trigger export. RealAgent creates or updates rows in your spreadsheet with IDs, URLs, prices, and metadata.",
      },
    ],
  },
  {
    id: "advanced",
    title: "5. Advanced Settings",
    icon: <Settings fontSize="small" />,
    subtitle: "Fine‑tune upload identity, descriptions, and automatic URL handling, and monitor your subscription.",
    steps: [
      {
        title: "Set upload display name",
        images: ["https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=800&q=80"],
        body: "Change the Upload Display Name to control how your profile appears on listings. Save the value and reuse it across all new uploads.",
      },
      {
        title: "Enable custom description",
        images: ["https://images.unsplash.com/photo-1455390582262-044cdead27d8?auto=format&fit=crop&w=800&q=80"],
        body: "Turn on Use custom description to apply a prepared text template for every upload. Edit the content when you want to refresh your tone.",
      },
      {
        title: "Auto‑fill URL from active tab",
        images: ["https://images.unsplash.com/photo-1481481600673-c6d1c638a18a?auto=format&fit=crop&w=800&q=80"],
        body: "Activate Auto‑fill URL from active tab to let RealAgent read the current Myhome/SS page address automatically and reduce manual copy‑paste.",
      },
      {
        title: "View subscription status",
        images: ["https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80"],
        body: "Use View Subscription Status to open a detailed breakdown of your active plan, renewal date, and any promotional pricing applied.",
      },
      {
        title: "Submit a problem report",
        images: ["https://images.unsplash.com/photo-1593642632823-8f785ba67e45?auto=format&fit=crop&w=800&q=80"],
        body: "If something behaves unexpectedly, use the Problem Report control to send context and details so issues can be investigated quickly.",
      },
    ],
  },
  {
    id: "session-reset",
    title: "6. Session Reset Modal",
    icon: <Refresh fontSize="small" />,
    subtitle: "Recover from outdated, mismatched, or broken sessions without touching your account or subscription.",
    steps: [
      {
        title: "When the reset modal appears",
        images: ["https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=800&q=80"],
        body: "The Session Reset modal appears when RealAgent detects stale data or conflicts between the extension and the active browser tab.",
      },
      {
        title: "What Reset actually clears",
        images: ["https://images.unsplash.com/photo-1618401471353-b98afee0b2eb?auto=format&fit=crop&w=800&q=80"],
        body: "Reset removes cached listing data and temporary state inside the extension only. Your RealAgent account, subscription, and Sheets stay intact.",
      },
      {
        title: "Recommended workflow after reset",
        images: ["https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=800&q=80"],
        body: "Click Reset Session, reload the listing page, then paste or auto‑fill the URL again. This gives you a clean start for fresh extraction.",
      },
    ],
  },
  {
    id: "updates",
    title: "7. Update & New Version Modal",
    icon: <Update fontSize="small" />,
    subtitle: "Stay on the latest RealAgent version and understand what changes in each release.",
    steps: [
      {
        title: "Recognize update notifications",
        images: ["https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=800&q=80"],
        body: "When a new version is published, RealAgent shows a highlight modal describing key improvements, fixes, and compatibility changes.",
      },
      {
        title: "Apply the update safely",
        images: ["https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&w=800&q=80"],
        body: "Use the Update or Refresh button inside the modal. If prompted, reload the extension pop‑up or browser tab to finish migration.",
      },
      {
        title: "Verify that the update is active",
        images: ["https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=800&q=80"],
        body: "After updating, check the version label or any new controls mentioned in the notes. If something looks off, submit a quick problem report.",
      },
    ],
  },
];

function Instructions() {
  const [activeTopicIndex, setActiveTopicIndex] = useState(0);
  const [activeStepIndex, setActiveStepIndex] = useState(0);

  const currentTopic = instructionsSections[activeTopicIndex];
  const currentStep = currentTopic.steps[activeStepIndex];
  
  const totalSteps = currentTopic.steps.length;
  const isFirstStep = activeStepIndex === 0;
  const isLastStep = activeStepIndex === totalSteps - 1;
  const isLastTopic = activeTopicIndex === instructionsSections.length - 1;

  const handleTopicChange = (index) => {
    setActiveTopicIndex(index);
    setActiveStepIndex(0);
  };

  const handleNextStep = () => {
    if (!isLastStep) {
      setActiveStepIndex((prev) => prev + 1);
    } else if (!isLastTopic) {
      handleTopicChange(activeTopicIndex + 1);
    }
  };

  const handlePrevStep = () => {
    if (!isFirstStep) {
      setActiveStepIndex((prev) => prev - 1);
    }
  };

  return (
    <div className="guide-wrapper">
      <div className="guide-container">
        
        <div className="guide-header">
          <h1 className="guide-main-title">RealAgent Usage Guide</h1>
          <p className="guide-subtitle">
            Everything you need to master RealAgent. Select a topic below and step through the interactive guide.
          </p>
        </div>

        <div className="guide-layout">
          {/* Left Sidebar */}
          <div className="guide-sidebar">
            {instructionsSections.map((section, index) => {
              const isActive = activeTopicIndex === index;
              return (
                <button
                  key={section.id}
                  onClick={() => handleTopicChange(index)}
                  className={`guide-topic-btn ${isActive ? "active" : ""}`}
                >
                  {section.icon}
                  <div className="guide-topic-titles">
                    <strong>{section.title}</strong>
                    {isActive && <span>{section.steps.length} steps</span>}
                  </div>
                </button>
              );
            })}
          </div>

          {/* Right Content */}
          <div className="guide-content">
            <div className="guide-content-header">
              <h2>{currentTopic.title}</h2>
              <p>{currentTopic.subtitle}</p>
            </div>

            <div className="guide-card">
              <AnimatePresence mode="wait">
                <motion.div
                  key={`${activeTopicIndex}-${activeStepIndex}`}
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -20 }}
                  transition={{ duration: 0.3, ease: "easeOut" }}
                  className="guide-slide-inner"
                >
                  <div className="guide-image-box">
                    {currentStep.images && currentStep.images.length > 0 && (
                      <img 
                        src={currentStep.images[0]} 
                        alt={currentStep.title}
                        onError={(e) => { e.target.style.display = 'none'; }}
                      />
                    )}
                  </div>

                  <div className="guide-text-box">
                    <div className="guide-step-badge">{activeStepIndex + 1}</div>
                    <h3>{currentStep.title}</h3>
                    <p>{currentStep.body}</p>
                  </div>
                </motion.div>
              </AnimatePresence>

              {/* Controls */}
              <div className="guide-controls">
                <button
                  onClick={handlePrevStep}
                  disabled={isFirstStep}
                  className="guide-btn-prev"
                >
                  <ArrowBack fontSize="small" /> Previous
                </button>

                <div className="guide-dots">
                  {currentTopic.steps.map((_, i) => (
                    <div 
                      key={i} 
                      className={`guide-dot ${i === activeStepIndex ? "active" : "inactive"}`}
                    />
                  ))}
                </div>

                <button
                  onClick={handleNextStep}
                  className="guide-btn-next"
                >
                  {isLastStep && !isLastTopic ? "Next Topic" : "Next Step"} <ArrowForward fontSize="small" />
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}


// Reuse authentication code with routing behavior
function Login() {
  const location = useLocation();
  const [initialEmail, setInitialEmail] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const extEmailParam = params.get('extEmail');
    if (extEmailParam) {
      setInitialEmail(decodeURIComponent(extEmailParam));
    }
  }, [location.search]);

  const user = useAuthState(auth)[0];
  if (user) return <Navigate to="/dashboard" />;

  return (
    <div style={{ padding: 40 }}>
      <AuthForm initialEmail={initialEmail} />
    </div>
  );
}


// import { auth } from "./firebase";

function Dashboard() {
  const [user] = useAuthState(auth);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingUploadName, setIsEditingUploadName] = useState(false);

  // User info states
  const [name, setName] = useState(t("dashboard.defaultName"));
  const [uploadName, setUploadName] = useState(t("dashboard.defaultUploadName"));
  const [plan, setPlan] = useState(null); // "daily", "weekly", "monthly", "6months", or null
  const [daysLeft, setDaysLeft] = useState(0);
  const [subChecked, setSubChecked] = useState(false);

  const checkAndUpdateSubscription = async (userId) => {
    try {
      const userDoc = await getDoc(doc(db, "users", userId));
      const userData = userDoc.data();

      if (!userData) return;

      const now = Date.now();
      const planExpiry = userData.planExpiry || 0;

      console.log("Current time:", new Date(now).toISOString());
      console.log("Plan expiry:", new Date(planExpiry).toISOString());
      console.log("Is expired?", planExpiry < now);

      if (userData.subscriptionActive && planExpiry && planExpiry < now) {
        console.log("⚠️ Subscription expired! Auto-deactivating...");

        await updateDoc(doc(db, "users", userId), {
          subscriptionActive: false,
          subscriptionType: "",
          planExpiry: null,
        });

        return {
          subscriptionActive: false,
          planExpiry: null,
          daysLeft: 0,
          expired: true,
        };
      }

      const daysLeft = planExpiry
        ? Math.ceil((planExpiry - now) / (24 * 60 * 60 * 1000))
        : 0;

      return {
        subscriptionActive: userData.subscriptionActive || false,
        subscriptionType: userData.subscriptionType || "",
        planExpiry: userData.planExpiry || null,
        daysLeft,
        expired: false,
      };
    } catch (error) {
      console.error("Error checking subscription:", error);
      return null;
    }
  };

const nameInputRef = useRef(null);
const uploadNameInputRef = useRef(null);

const focusInputEnd = (inputRef) => {
  const el = inputRef.current;
  if (!el) return;
  const length = el.value.length;

  requestAnimationFrame(() => {
    el.focus();                          // makes the caret blink
    // guard in case browser / MUI swapped the element
    if (typeof el.setSelectionRange === "function") {
      el.setSelectionRange(length, length);
    }
  });
};



  useEffect(() => {
    if (user?.uid) {
      checkAndUpdateSubscription(user.uid);
    }
  }, [user?.uid]);

  useEffect(() => {
    if (!user?.uid) return;

    let ignore = false;

    const fetchSubData = async () => {
      try {
        console.log("📍 Dashboard: Fetching subscription for user", user.uid);

        const userDocRef = doc(db, "users", user.uid);
        const userDocSnap = await getDoc(userDocRef);

        if (ignore) return;

        if (!userDocSnap.exists()) {
          console.log("❌ User doc does not exist");
          setSubChecked(true);
          return;
        }

        const userData = userDocSnap.data();
        console.log("✅ User data retrieved:", userData);

        if (userData.subscriptionActive && userData.planExpiry) {
          const now = Date.now();
          const expiry = userData.planExpiry;

          let expiryMs = expiry;
          if (typeof expiry === "object" && expiry.seconds) {
            expiryMs = expiry.seconds * 1000;
          }

          console.log("⏰ Current time:", new Date(now).toISOString());
          console.log("⏰ Expiry time:", new Date(expiryMs).toISOString());

          if (now < expiryMs) {
            const daysLeftCalc = Math.ceil(
              (expiryMs - now) / (24 * 60 * 60 * 1000)
            );
            setPlan(userData.subscriptionType || "monthly");
            setDaysLeft(Math.max(0, daysLeftCalc));

            console.log(
              "✅ Active subscription:",
              userData.subscriptionType,
              "Days left:",
              daysLeftCalc
            );
          } else {
            console.log("⏰ Subscription expired! Auto-deactivating...");
            await updateDoc(userDocRef, {
              subscriptionActive: false,
              subscriptionType: "",
              planExpiry: null,
            });
            setPlan(null);
            setDaysLeft(0);
          }
        } else {
          console.log("❌ No active subscription");
          setPlan(null);
          setDaysLeft(0);
        }

        if (userData.name) setName(userData.name);
        if (userData.uploadName) setUploadName(userData.uploadName);

        setSubChecked(true);
      } catch (error) {
        console.error("❌ Error fetching subscription data:", error);
        setSubChecked(true);
      }
    };

    fetchSubData();

    return () => {
      ignore = true;
    };
  }, [user?.uid]);

  if (!user) return <Navigate to="/login" />;

  const buttonStyle = {
    fontWeight: 700,
    background: "none",
    color: "#1786c7",
    border: "2px solid #1786c7",
    borderRadius: 9,
    fontSize: 16,
    padding: "12px 26px",
    cursor: "pointer",
    transition: "background .18s, color .16s, box-shadow .17s",
  };

  function shineOn(e) {
    e.target.style.background =
      "linear-gradient(90deg,#47b2e4 25%,#c4f5ffB0 100%)";
    e.target.style.color = "#fff";
    e.target.style.boxShadow = "0 2px 12px #39aed93d";
    e.target.style.borderColor = "#47b2e4";
  }

  function shineOff(e) {
    if (e.target.classList.contains("dashboardLink")) {
      e.target.style.background =
        "linear-gradient(90deg,#39AED9, #16a5cf 120%)";
      e.target.style.color = "#fff";
      e.target.style.boxShadow = "0 2px 9px #44c2e43d";
    } else if (e.target.classList.contains("main-nav")) {
      e.target.style.background = "none";
      e.target.style.color = "#39AED9";
      e.target.style.boxShadow = "none";
    } else if (e.target.classList.contains("info-nav")) {
      e.target.style.background = "none";
      e.target.style.color = "#497bb7";
      e.target.style.boxShadow = "none";
    } else {
      e.target.style.background = "none";
      e.target.style.color = "#1786c7";
      e.target.style.boxShadow = "none";
      e.target.style.borderColor = "#1786c7";
    }
  }

  // Simple prompt-based editing for now
const handleEditName = () => {
  const newName = window.prompt('Enter your full name', name || '');
  if (!newName || !newName.trim()) return;
  setName(newName.trim());
  // TODO: also update Firestore
};

const handleEditUploadName = () => {
  const newUploadName = window.prompt('Enter your upload name', uploadName || '');
  if (!newUploadName || !newUploadName.trim()) return;
  setUploadName(newUploadName.trim());
  // TODO: also update Firestore
};

const saveNameToFirestore = async () => {
  if (!user?.uid) return;
  const trimmed = name.trim();
  if (!trimmed) return;
  try {
    await updateDoc(doc(db, "users", user.uid), {
      name: trimmed,
    });
  } catch (err) {
    console.error("Error updating full name in Firestore", err);
  }
};

const saveUploadNameToFirestore = async () => {
  if (!user?.uid) return;
  const trimmed = uploadName.trim();
  if (!trimmed) return;
  try {
    await updateDoc(doc(db, "users", user.uid), {
      uploadName: trimmed,
    });
  } catch (err) {
    console.error("Error updating upload name in Firestore", err);
  }
};



return (
  <Box
    sx={{
      minHeight: '100vh',
      background: 'linear-gradient(180deg, #e9f4ff 0%, #f8fafc 40%)',
      py: 4,
      px: 2,
    }}
  >
    <Container maxWidth="lg">
      {/* Single Unified Card */}
      <Paper
        elevation={0}
        sx={{
          border: '1px solid #d2e3f0',
          borderRadius: '20px',
          overflow: 'hidden',
          transition: 'box-shadow 0.3s ease, transform 0.2s ease',
          background: '#ffffff',
          '&:hover': {
            boxShadow: '0 10px 30px rgba(15, 51, 179, 0.10)',
            transform: 'translateY(-2px)',
          },
        }}
      >
        {/* Header Section with Avatar */}
        <Box
          sx={{
            background: 'linear-gradient(135deg, #177FBA 0%, #39AED9 40%, #0f33b3 100%)',
            p: 4,
            color: 'white',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <Avatar
              sx={{
                width: 80,
                height: 80,
                fontSize: '36px',
                fontWeight: 700,
                bgcolor: 'rgba(255, 255, 255, 0.18)',
                border: '3px solid rgba(255, 255, 255, 0.55)',
                boxShadow: '0 0 0 4px rgba(15,51,179,0.25)',
              }}
            >
              {(name || user?.email || 'U').charAt(0).toUpperCase()}
            </Avatar>
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 800,
                  fontSize: '32px',
                  letterSpacing: '0.02em',
                  mb: 0.5,
                }}
              >
                Dashboard
              </Typography>
              <Typography
                sx={{
                  fontSize: '16px',
                  opacity: 0.96,
                  fontWeight: 500,
                }}
              >
                {name || t('dashboard.defaultName')}
              </Typography>
              <Typography
                sx={{
                  fontSize: '13px',
                  opacity: 0.9,
                  mt: 0.25,
                }}
              >
                {user?.email}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Content Section */}
        <Box sx={{ p: 4 }}>
          <Grid container spacing={0}>
            {/* Left Column - fixed width profile area */}
             <Grid
                item
                xs={12}
                md={5}
                sx={{
                  pr: { xs: 0, md: 4 },
                  borderRight: { xs: 'none', md: '1px solid #e2e8f0' },
                  pb: { xs: 3, md: 0 },
                  minWidth: { md: 320 },    // ensure a decent minimum
                  maxWidth: { md: 420 },    // allow it to actually get wide
                }}
              >

              <Typography
                variant="h6"
                sx={{
                  fontSize: '18px',
                  fontWeight: 700,
                  color: '#0f172a',
                  mb: 3,
                  pb: 2,
                  borderBottom: '2px solid #e2e8f0',
                }}
              >
                Profile Information
              </Typography>

              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {/* Profile fields container */}
<Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
  {/* Full Name */}
  <Box>
    <Typography
      variant="caption"
      sx={{
        fontSize: '11px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '1px',
        color: '#64748b',
        display: 'block',
        mb: 1,
      }}
    >
      Full Name
    </Typography>

<Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    px: 3.0,            // wider horizontally
    py: 2,   
    width: "100%",
    bgcolor: isEditingName ? "#e0f2fe" : "#f8fbff",
    borderRadius: "12px",
    border: isEditingName ? "1.5px solid #177FBA" : "1px solid #dbeafe",
    boxShadow: isEditingName
      ? "0 0 0 0 rgba(23, 127, 186, 0.45)"
      : "none",
    animation: isEditingName ? "inputBorderPulse 1.4s ease-in-out infinite" : "none",
    transition:
      "box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease",
    "&:hover": {
      bgcolor: isEditingName ? "#dbeafe" : "#eff6ff",
      borderColor: "#177FBA",
      boxShadow: isEditingName
        ? "0 0 0 0 rgba(23, 127, 186, 0.45)"
        : "0 4px 10px rgba(15, 51, 179, 0.08)",
    },
  }}
>
 <Box
  sx={{
    flex: 1,
    minWidth: 0,
    mr: 1.5
    }}>
    {isEditingName ? (
      <TextField
        inputRef={nameInputRef}
        variant="standard"
        fullWidth
        value={name}
        onChange={(e) => setName(e.target.value)}
        InputProps={{ disableUnderline: true }}
        sx={{
          fontSize: "15px",
          fontWeight: 600,
          color: "#0f172a",
          p: 0,
          "& .MuiInputBase-input": {
            padding: 0,
          },
        }}
      />
    ) : (
      <Typography
        sx={{
          fontSize: "15px",
          fontWeight: 600,
          color: "#0f172a",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {name || t("dashboard.defaultName")}
      </Typography>
    )}
  </Box>
  {/* controls Box unchanged */}


  {/* existing Controls Box stays the same */}


      {/* Controls – fixed width so row width is constant */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 1,
          ml: 2,
          width: 185, 
          flexShrink: 0,
        }}
      >
   {isEditingName ? (
  <>
    <Button
      size="small"
      onClick={async () => {
        await saveNameToFirestore();
        setIsEditingName(false);
      }}
      sx={{
        color: "#177FBA",
        fontSize: "13px",
        fontWeight: 600,
        textTransform: "none",
      }}
    >
      Save
    </Button>
    <Button
      size="small"
      onClick={() => setIsEditingName(false)}
      sx={{
        color: "#64748b",
        fontSize: "13px",
        fontWeight: 500,
        textTransform: "none",
      }}
    >
      Cancel
    </Button>
  </>
) : (
         <Button
            variant="text"
            size="small"
            onClick={() => {
              setIsEditingName(true);
              setTimeout(() => focusInputEnd(nameInputRef), 0);

            }}
            sx={{
              color: '#177FBA',
              fontSize: '13px',
              fontWeight: 600,
              textTransform: 'none',
              minWidth: 'auto',
              px: 1.5,
              '&:hover': {
                bgcolor: 'rgba(23, 127, 186, 0.08)',
              },
            }}
          >
            Edit
          </Button>
        )}
      </Box>
    </Box>
  </Box>

  {/* Upload Name */}
  <Box>
    <Typography
      variant="caption"
      sx={{
        fontSize: '11px',
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: '1px',
        color: '#64748b',
        display: 'block',
        mb: 1,
      }}
    >
      Upload Name
    </Typography>

<Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    px: 3.0,            // wider horizontally
    py: 2,   
    width: "100%",
    bgcolor: isEditingUploadName ? "#e0f2fe" : "#f8fbff",
    borderRadius: "12px",
    border: isEditingUploadName ? "1.5px solid #177FBA" : "1px solid #dbeafe",
    boxShadow: isEditingUploadName
      ? "0 0 0 0 rgba(23, 127, 186, 0.45)"
      : "none",
    animation: isEditingUploadName
      ? "inputBorderPulse 1.4s ease-in-out infinite"
      : "none",
    transition:
      "box-shadow 0.18s ease, border-color 0.18s ease, background 0.18s ease",
    "&:hover": {
      bgcolor: isEditingUploadName ? "#dbeafe" : "#eff6ff",
      borderColor: "#177FBA",
      boxShadow: isEditingUploadName
        ? "0 0 0 0 rgba(23, 127, 186, 0.45)"
        : "0 4px 10px rgba(15, 51, 179, 0.08)",
    },
  }}
>
  <Box
  sx={{
    flex: 1,
    minWidth: 0,
    mr: 1.5
     }}>
    {isEditingUploadName ? (
      <TextField
        inputRef={uploadNameInputRef}
        variant="standard"
        fullWidth
        value={uploadName}
        onChange={(e) => setUploadName(e.target.value)}
        InputProps={{ disableUnderline: true }}
        sx={{
          fontSize: "15px",
          fontWeight: 600,
          color: "#0f172a",
          p: 0,
          "& .MuiInputBase-input": {
            padding: 0,
          },
        }}
      />
    ) : (
      <Typography
        sx={{
          fontSize: "15px",
          fontWeight: 600,
          color: "#0f172a",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {uploadName || t("dashboard.defaultUploadName")}
      </Typography>
    )}
  </Box>
  

  {/* existing Controls Box stays the same */}


      {/* Controls – fixed width so row width is constant */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: 1,
          ml: 2,
          width: 185,   
          flexShrik: 0,
        }}
      >
       {isEditingUploadName ? (
          <>
            <Button
              size="small"
              onClick={async () => {
                await saveUploadNameToFirestore();
                setIsEditingUploadName(false);
              }}
              sx={{
                color: "#177FBA",
                fontSize: "13px",
                fontWeight: 600,
                textTransform: "none",
              }}
            >
              Save
            </Button>
            <Button
              size="small"
              onClick={() => setIsEditingUploadName(false)}
              sx={{
                color: "#64748b",
                fontSize: "13px",
                fontWeight: 500,
                textTransform: "none",
              }}
            >
              Cancel
            </Button>
          </>
        ) : (
          <Button
            variant="text"
            size="small"
            onClick={() => {
              setIsEditingUploadName(true);
              setTimeout(() => focusInputEnd(uploadNameInputRef), 0);
            }}
            sx={{
              color: '#177FBA',
              fontSize: '13px',
              fontWeight: 600,
              textTransform: 'none',
              minWidth: 'auto',
              px: 1.5,
              '&:hover': {
                bgcolor: 'rgba(23, 127, 186, 0.08)',
              },
            }}
          >
            Edit
          </Button>
        )}
      </Box>
    </Box>
  </Box>
</Box>
</Box>

            </Grid>

            {/* Right Column - subscription in remaining space, pushed right */}
            <Grid
              item
              xs={12}
              md={7}
              sx={{
                pl: { xs: 0, md: 6 },
                pt: { xs: 3, md: 0 },
              }}
            >
            <Box
              sx={{
                width: '100%',
                maxWidth: 380,          // slightly narrower card
                mr: { xs: 0, md: 8 },   // bigger right margin
              }}
            >

                {/* Increase maxWidth and add marginLeft to move further right */}
                <Box
                  sx={{
                    width: '100%',
                    maxWidth: 420,
                    mr: { xs: 0, md: 4 },   // pushes card toward right
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: '18px',
                      fontWeight: 700,
                      color: '#0f172a',
                      mb: 3,
                      pb: 2,
                      borderBottom: '2px solid #e2e8f0',
                    }}
                  >
                    Subscription Status
                  </Typography>

                  {plan ? (
                    <Box
                      sx={{
                        p: 3,
                        bgcolor: 'linear-gradient(135deg,#eff6ff 0%,#dbeafe 40%,#e0f2fe 100%)',
                        borderRadius: '14px',
                        border: '1px solid #bfdbfe',
                        boxShadow: '0 6px 16px rgba(15,51,179,0.10)',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'flex-start',
                          gap: 1.5,    // tighter spacing between text and badge
                          mb: 2,
                          columnGap: 3,
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: '15px',
                            fontWeight: 600,
                            color: '#0f172a',
                          }}
                        >
                          {t(`dashboard.planTypes.${plan.toLowerCase()}`, plan)} Plan
                        </Typography>
                    <Box
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 0.75,
                        px: 1.8,
                        py: 0.4,
                        borderRadius: '999px',
                        fontSize: '11px',
                        fontWeight: 600,
                        bgcolor: '#ecfdf5',
                        color: '#059669',
                        border: '1px solid #bbf7d0',
                      }}
                    >
                      ● Active
                    </Box>
                  </Box>

                      <Box
                        sx={{
                          textAlign: 'center',
                          py: 3,
                          bgcolor: 'rgba(255,255,255,0.9)',
                          borderRadius: '10px',
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: '46px',
                            fontWeight: 800,
                            color: '#0f33b3',
                            lineHeight: 1,
                            mb: 0.5,
                          }}
                        >
                          {daysLeft}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: '14px',
                            color: '#475569',
                            fontWeight: 500,
                          }}
                        >
                          days remaining
                        </Typography>
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        p: 3,
                        textAlign: 'center',
                        bgcolor: '#f8fbff',
                        borderRadius: '14px',
                        border: '1px dashed #bfdbfe',
                        boxShadow: '0 4px 12px rgba(15,51,179,0.05)',
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: '16px',
                          fontWeight: 600,
                          color: '#1e293b',
                          mb: 1,
                        }}
                      >
                        No Active Subscription
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '14px',
                          color: '#64748b',
                        }}
                      >
                        Subscribe to unlock all features
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>

          {/* Action Buttons */}
          <Box
            sx={{
              mt: 4,
              pt: 4,
              borderTop: '2px solid #e2e8f0',
            }}
          >
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} sm={5} md={4}>
                {!plan ? (
                  <Button
                    variant="contained"
                    fullWidth
                    onClick={() => navigate('/pricing')}
                    sx={{
                      py: 1.75,
                      bgcolor: '#177FBA',
                      color: 'white',
                      fontSize: '15px',
                      fontWeight: 600,
                      borderRadius: '999px',
                      textTransform: 'none',
                      boxShadow: '0 6px 18px rgba(23,127,186,0.35)',
                      transition: 'all 0.25s ease',
                      '&:hover': {
                        bgcolor: '#0f33b3',
                        boxShadow: '0 8px 22px rgba(15,51,179,0.45)',
                        transform: 'translateY(-2px)',
                      },
                    }}
                  >
                    Activate Package
                  </Button>
                ) : (
                  <Button
                    variant="outlined"
                    fullWidth
                    onClick={() => navigate('/')}
                    sx={{
                      py: 1.75,
                      color: '#0f172a',
                      border: '1px solid #d0e2ff',
                      fontSize: '14px',
                      fontWeight: 500,
                      borderRadius: '999px',
                      textTransform: 'none',
                      transition: 'all 0.25s ease',
                      '&:hover': {
                        borderColor: '#177FBA',
                        bgcolor: '#eff6ff',
                        color: '#0f33b3',
                        transform: 'translateY(-2px)',
                        boxShadow: '0 6px 16px rgba(23,127,186,0.25)',
                      },
                    }}
                  >
                    Go to Home
                  </Button>
                )}
              </Grid>

              <Grid item xs={12} sm={5} md={3}>
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={() => auth.signOut()}
                  sx={{
                    py: 1.75,
                    color: '#ef4444',
                    border: '1px solid #fee2e2',
                    fontSize: '14px',
                    fontWeight: 500,
                    borderRadius: '999px',
                    textTransform: 'none',
                    position: 'relative',
                    overflow: 'hidden',
                    background: '#fff',
                    transition: 'all 0.25s ease',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: '-120%',
                      width: '120%',
                      height: '100%',
                      background:
                        'linear-gradient(90deg, transparent, rgba(239, 68, 68, 0.10), transparent)',
                      transition: 'left 0.55s ease',
                    },
                    '&:hover': {
                      borderColor: '#ef4444',
                      bgcolor: '#fef2f2',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 6px 18px rgba(239,68,68,0.25)',
                      '&::before': {
                        left: '120%',
                      },
                    },
                    '&:active': {
                      transform: 'scale(0.97)',
                    },
                  }}
                >
                  Logout
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Paper>
    </Container>
  </Box>
);


}







function AuthForm({ initialEmail }) {
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState(initialEmail);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // 👈 ADD THIS LINE
  const [name, setName] = useState("");
  const [uploadName, setUploadName] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (initialEmail) setEmail(initialEmail);
  }, [initialEmail]);

  const submitHandler = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);
    try {
      if (isRegister) {
        if (!name || !uploadName) {
          setMessage("Please enter your name and upload display name.");
          setLoading(false);
          return;
        }

        await createUserWithEmailAndPassword(auth, email, password);
        const user = auth.currentUser;
        await user.updateProfile({ displayName: name });
        await setDoc(
          doc(db, "users", user.uid),
          { email, name, uploadName, createdAt: Date.now() },
          { merge: true }
        );
        setMessage("Registration successful! You are logged in.");
      } else {
        await signInWithEmailAndPassword(auth, email, password);
        const user = auth.currentUser;
        if (user && (name || uploadName)) {
          await setDoc(
            doc(db, "users", user.uid),
            {
              email,
              ...(name && { name }),
              ...(uploadName && { uploadName }),
            },
            { merge: true }
          );
        }
        setMessage("Login successful!");
      }
    } catch (error) {
      setMessage(error.message);
    } finally {
      setLoading(false);
    }
  };
const handleGoogleWebAuth = async () => {
    setMessage("");
    setLoading(true);
    try {
      const provider = new GoogleAuthProvider();
      // This triggers the standard Google login popup
      const result = await signInWithPopup(auth, provider);
      
      // Check if this is their first time logging in
      const isNew = getAdditionalUserInfo(result)?.isNewUser;

      if (isNew) {
        // Create their Firestore profile so the dashboard doesn't break
        await setDoc(
          doc(db, "users", result.user.uid),
          {
            email: result.user.email,
            name: result.user.displayName || "Google User",
            uploadName: result.user.displayName || "Google User",
            googleAccountLinked: true,
            createdAt: Date.now(),
          },
          { merge: true }
        );
        setMessage("Google registration successful!");
      } else {
        setMessage("Google login successful!");
      }
    } catch (error) {
      console.error("Google Web Auth Error:", error);
      // Ignore the error if the user just closed the popup manually
      if (error.code !== 'auth/popup-closed-by-user') {
        setMessage(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={submitHandler}
      style={{
        width: "100%",
        maxWidth: 360,
        background: "linear-gradient(145deg,#ffffff,#f2f7ff)",
        borderRadius: 18,
        boxShadow:
          "0 18px 40px rgba(15,37,75,0.16), 0 0 0 1px rgba(148,176,212,0.3)",
        padding: "32px 26px 24px 26px",
        margin: "30px auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        boxSizing: "border-box",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          pointerEvents: "none",
          background:
            "radial-gradient(circle at 0 0, rgba(72,187,255,0.20), transparent 55%)",
          opacity: 0.9,
        }}
      />

      <h3
        style={{
          margin: "0 0 22px 0",
          color: "#111827",
          fontWeight: 800,
          fontSize: 26,
          textAlign: "left",
          position: "relative",
          zIndex: 1,
        }}
      >
        {isRegister ? "Create your account" : "Welcome back"}
      </h3>

      {isRegister && (
        <>
          <label
            style={{ color: "#498bb9", fontWeight: 600, marginBottom: 4 }}
          >
            Full Name
          </label>
          <input
            value={name}
            type="text"
            autoComplete="name"
            onChange={(e) => setName(e.target.value)}
            placeholder="Your Name"
            style={{
              marginBottom: 14,
              padding: 12,
              borderRadius: 8,
              border: "1.2px solid #c5e7f8",
              fontSize: 17,
            }}
          />

          <label
            style={{ color: "#498bb9", fontWeight: 600, marginBottom: 4 }}
          >
            Upload Display Name
          </label>
          <input
            value={uploadName}
            type="text"
            onChange={(e) => setUploadName(e.target.value)}
            placeholder="Display name for uploads"
            style={{
              marginBottom: 14,
              padding: 12,
              borderRadius: 8,
              border: "1.2px solid #c5e7f8",
              fontSize: 17,
            }}
          />
        </>
      )}

      <label style={{ color: "#498bb9", fontWeight: 600, marginBottom: 4 }}>
        Email
      </label>
      <input
        value={email}
        type="email"
        autoComplete="email"
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Email address"
        style={{
          marginBottom: 14,
          padding: 12,
          borderRadius: 8,
          border: "1.2px solid #c5e7f8",
          fontSize: 17,
        }}
      />

<label style={{ color: "#498bb9", fontWeight: 600, marginBottom: 4 }}>
        Password
      </label>
      
      {/* --- NEW WRAPPER DIV JUST FOR THE PASSWORD INPUT --- */}
      <div style={{ position: "relative", marginBottom: 20 }}>
        <input
          value={password}
          type={showPassword ? "text" : "password"}
          autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          style={{
            width: "100%",
            padding: "12px 42px 12px 12px", // Added right padding for the icon
            borderRadius: 8,
            border: "1.2px solid #c5e7f8",
            fontSize: 17,
            boxSizing: "border-box", 
            outline: "none",
            transition: "border-color 0.2s, box-shadow 0.2s",
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#39AED9";
            e.target.style.boxShadow = "0 0 0 3px rgba(57, 174, 217, 0.15)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "#c5e7f8";
            e.target.style.boxShadow = "none";
          }}
        />
        
        {/* The Show/Hide Toggle Button */}
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          style={{
            position: "absolute",
            right: 12,
            top: "50%",
            transform: "translateY(-50%)",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: showPassword ? "#39AED9" : "#94a3b8",
            transition: "color 0.2s",
          }}
          aria-label={showPassword ? "Hide password" : "Show password"}
        >
          {showPassword ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
              <line x1="1" y1="1" x2="23" y2="23"></line>
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
          )}
        </button>
      </div>
      {/* --- END PASSWORD WRAPPER --- */}

      {/* --- YOUR EXACT SUBMIT BUTTON (100% UNTOUCHED) --- */}
      <button
        type="submit"
        disabled={loading}
        style={{
          padding: "13px",
          background: loading
            ? "linear-gradient(90deg,#93c5fd,#3b82f6)"
            : "#39AED9",
          color: "#fff",
          border: "none",
          borderRadius: 999,
          fontWeight: 700,
          fontSize: 17,
          marginBottom: 16,
          marginTop: 16,
          cursor: loading ? "default" : "pointer",
          boxShadow: loading
            ? "0 0 0 1px rgba(59,130,246,0.3)"
            : "0 2px 12px rgba(55,160,215,0.40)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          transition: "transform 0.12s ease-out, box-shadow 0.12s ease-out",
          transform: "translateY(0)",
        }}
      >
        {loading && (
          <span
            style={{
              width: 18,
              height: 18,
              borderRadius: "999px",
              border: "2px solid rgba(255,255,255,0.35)",
              borderTopColor: "#ffffff",
              animation: "spin 0.7s linear infinite",
            }}
          />
        )}
        <span>{isRegister ? "Create account" : "Log in"}</span>
      </button>
    {/* --- NEW GOOGLE AUTH BUTTON --- */}
      <div style={{ display: "flex", alignItems: "center", margin: "8px 0 24px 0" }}>
        <div style={{ flex: 1, height: "1px", backgroundColor: "#c5e7f8" }}></div>
        <span style={{ margin: "0 14px", color: "#64748b", fontSize: 14, fontWeight: 600 }}>OR</span>
        <div style={{ flex: 1, height: "1px", backgroundColor: "#c5e7f8" }}></div>
      </div>

      <button
        type="button"
        onClick={handleGoogleWebAuth}
        disabled={loading}
        style={{
          padding: "12px",
          background: "#ffffff",
          color: "#374151",
          border: "1.5px solid #d1d5db",
          borderRadius: 999,
          fontWeight: 700,
          fontSize: 16,
          marginBottom: 16,
          cursor: loading ? "default" : "pointer",
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 12,
          transition: "background 0.15s, border-color 0.15s",
        }}
        onMouseEnter={(e) => {
          if (!loading) {
            e.currentTarget.style.background = "#f9fafb";
            e.currentTarget.style.borderColor = "#9ca3af";
          }
        }}
        onMouseLeave={(e) => {
          if (!loading) {
            e.currentTarget.style.background = "#ffffff";
            e.currentTarget.style.borderColor = "#d1d5db";
          }
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
        </svg>
        <span>Continue with Google</span>
      </button>
      {/* --- END NEW GOOGLE AUTH BUTTON --- */}
      <div
        style={{
          textAlign: "center",
          marginBottom: 10,
          position: "relative",
          zIndex: 1,
        }}
      >
        <button
          type="button"
          onClick={() => setIsRegister((v) => !v)}
          style={{
            background: "none",
            border: "none",
            color: "#2563eb",
            cursor: "pointer",
            fontSize: 14,
            textDecoration: "underline",
          }}
        >
          {isRegister
            ? "Already have an account? Log in"
            : "New here? Create an account"}
        </button>
      </div>

      {message && (
        <div
          style={{
            marginTop: 6,
            color: message.includes("successful")
              ? "#16a34a"
              : "#dc2626",
            fontWeight: 600,
            textAlign: "center",
            fontSize: 13,
            position: "relative",
            zIndex: 1,
          }}
        >
          {message}
        </div>
      )}
    </form>
  );
}



// Navbar component
function Navbar() {
  const [user] = useAuthState(auth);
  const { t } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const location = useLocation();


  // Main nav links
  const mainLinks = [
    { to: "/", text: t('navbar.home'), minWidth: 92 },
    { to: "/pricing", text: t('navbar.pricing'), minWidth: 94 },
  ];

  // Dropdown legal menu links
  const legalLinks = [
    { to: "/about", label: t('legal.about_title') },
    { to: "/PaymentandRefundPolicy", label: t('navbar.policy') },
    { to: "/PrivacyPolicy", label: t('navbar.privacy') },
    { to: "/TermsConditions", label: t('navbar.TermsConditions') },
    { to: "/Contact", label: t('navbar.contact') }
  ];

  const navLinkStyle = {
    color: "#39AED9",
    fontWeight: 700,
    borderRadius: 10,
    padding: "7px 13px", // MAKE BIGGER!
    fontSize: 17,         // MAKE BIGGER!
    letterSpacing: ".01em",
    lineHeight: "38px",
    background: "none",
    textDecoration: "none",
    whiteSpace: "nowrap",
    display: "inline-block",
    textAlign: "center",
    transition: "background .15s, color .14s"
  };

  const legalLinkStyle = {
    color: "#497bb7",
    fontFamily: '"Inter", "Segoe UI", Arial, sans-serif',
    fontWeight: 700,
    fontSize: 16,              // MAKE BIGGER!
    borderRadius: 10,
    padding: "7px 13px",      // MAKE BIGGER!
    background: "none",
    textDecoration: "none",
    whiteSpace: "nowrap",
    display: "inline-block",
    textAlign: "center",
    transition: "background .15s, color .14s, box-shadow .15s",
    boxShadow: "none",
    letterSpacing: ".008em"
  };

  const dashboardLinkStyle = {
    ...navLinkStyle,
    background: "linear-gradient(90deg,#39AED9, #16a5cf 120%)",
    color: "#fff",
    fontSize: 17,
    fontWeight: 800,
    border: "none",
    marginLeft: 12,
    padding: "7px 13px", // EVEN BIGGER!
    boxShadow: "0 2px 13px #44c2e43d"
  };

  const dividerStyle = {
    height: 45, // taller to match bigger buttons
    width: 2,
    background: "linear-gradient(110deg,#b2deec 50%,#39AED9 120%)",
    margin: "0 18px"
  };

  function shineOn(e) {
    e.target.style.background = "linear-gradient(90deg,#47b2e4 30%,#c4f5ffB0 100%)";
    e.target.style.color = "#fff";
    e.target.style.boxShadow = "0 2px 13px #39aed93d";
  }
  function shineOff(e) {
    e.target.style.background = "none";
    if (e.target.classList.contains('main-nav')) {
      e.target.style.color = "#39AED9";
    } else if (e.target.classList.contains('dashboardLink')) {
      e.target.style.color = "#fff";
    } else {
      e.target.style.color = "#497bb7";
    }
    e.target.style.boxShadow = "none";
  }


  // Add document click handler: close dropdown ONLY if clicked outside
  React.useEffect(() => {
    function handleDocumentClick(e) {
      if (dropdownOpen && !e.target.closest('.navbar-dropdown-root')) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleDocumentClick);
    return () => document.removeEventListener('mousedown', handleDocumentClick);
  }, [dropdownOpen]);

  React.useEffect(() => {
    // On mount, always reset dashboard link styles if present
    const dashEl = document.querySelector('.dashboardLink');
    if (dashEl) {
      dashEl.style.background = "";
      dashEl.style.color = "";
      dashEl.style.boxShadow = "";
    }
  }, [user]);


return (
  <nav
    style={{
      display: "flex",
      alignItems: "center",
      background: "#242635",
      padding: "14px 42px",
      height: 84,
      minHeight: 84,
      boxSizing: "border-box",
      fontFamily: '"Inter", "Segoe UI", Arial, sans-serif',
      zIndex: 130,
    }}
  >
    {/* LEFT: 3 main buttons (Home, Pricing, Company) */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 14,
        marginLeft: 24, // tweak this value until it looks perfect
        flexShrink: 0,
      }}
    >
      {/* Home + Pricing from mainLinks */}
      {mainLinks.map((link) => (
        <Link
          key={link.to}
          to={link.to}
          className={
            "main-nav" + (location.pathname === link.to ? " active" : "")
          }
          style={{
            ...navLinkStyle,
            minWidth: link.minWidth,
          }}
          onMouseEnter={shineOn}
          onMouseLeave={shineOff}
        >
          {link.text}
        </Link>
      ))}

      {/* Company dropdown (3rd main button) */}
      <div
        style={{
          position: "relative",
          display: "inline-block",
        }}
        tabIndex={0}
        className="navbar-dropdown-root"
      >
        {/* Button */}
        <span
          style={{
            ...legalLinkStyle,
            cursor: "pointer",
            minWidth: 90,
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
          onClick={() => setDropdownOpen((prev) => !prev)}
          onMouseEnter={shineOn}
          onMouseLeave={shineOff}
        >
          {t("navbar.about")}
          <span
            style={{
              marginLeft: 10,
              fontSize: 20,
              color: "#497bb7",
              display: "inline-block",
              lineHeight: "16px",
            }}
          >
            {dropdownOpen ? "▴" : "▾"}
          </span>
        </span>

        {/* Dropdown menu */}
        {dropdownOpen && (
          <div
            className="navbar-dropdown-menu"
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              background: "#f9faff",
              borderRadius: 14,
              boxShadow: "0 6px 39px #a6c8e824",
              padding: "13px 0",
              minWidth: 210,
              zIndex: 5000,
              border: "1px solid #d3e7fa",
              marginTop: 12,
            }}
          >
            {[
              { to: "/about", label: t("legal.about_title") },
              {
                to: "/PaymentandRefundPolicy",
                label: t("navbar.policy"),
              },
              { to: "/PrivacyPolicy", label: t("navbar.privacy") },
              {
                to: "/TermsConditions",
                label: t("navbar.TermsConditions"),
              },
              { to: "/Contact", label: t("navbar.contact") },
            ].map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className={
                  "navbar-dropdown-item" +
                  (location.pathname === item.to ? " active" : "")
                }
                style={{
                  ...legalLinkStyle,
                  display: "block",
                  fontSize: 18,
                  padding: "14px 30px",
                  minWidth: 180,
                  textAlign: "left",
                }}
                onClick={() => setDropdownOpen(false)}
                onMouseEnter={shineOn}
                onMouseLeave={shineOff}
              >
                {item.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>

    {/* Filler flex to keep right side fixed even when email pill hides */}
    <div style={{ flexGrow: 1 }} />

    {/* RIGHT: user pill, dashboard/login, language */}
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        flexShrink: 0,
      }}
    >
      {/* Email pill – only when user exists */}
      {user && (
        <div
          style={{
            maxWidth: 220,
            padding: "6px 10px",
            borderRadius: 999,
            background:
              "radial-gradient(circle at 0 0, #e0f4ff 0, #ffffff 40%, #d4ebff 100%)",
            display: "flex",
            alignItems: "center",
            gap: 8,
            boxShadow: "0 2px 9px rgba(31, 96, 162, 0.18)",
            border: "1px solid #c2ddf8",
            fontSize: 13,
            color: "#1e3a8a",
            fontWeight: 600,
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
          }}
          title={user.email || ""}
        >
          <span
            style={{
              width: 24,
              height: 24,
              borderRadius: 999,
              background: "linear-gradient(135deg, #39AED9, #1786c7)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              fontSize: 13,
              fontWeight: 700,
            }}
          >
            {(user.email?.[0] || "U").toUpperCase()}
          </span>
          <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
            {user.email}
          </span>
        </div>
      )}

      {/* Dashboard / Login button */}
      <Link
        to={user ? "/dashboard" : "/login"}
        className="dashboardLink"
        onMouseEnter={shineOn}
        onMouseLeave={shineOff}
      >
        {user ? t("navbar.dashboard") : t("navbar.login")}
      </Link>

      {/* Language switcher */}
      <LanguageSwitcher />
    </div>
  </nav>
);

}


// Add this BEFORE the <Router> in App.js

function ProtectedRouter() {
  const [user] = useAuthState(auth);
  const [userData, setUserData] = useState(null);

  const location = useLocation();

  useEffect(() => {
    if (!user) {
      setUserData(null);
      return;
    }

    const ref = doc(db, "users", user.uid);
    const unsub = onSnapshot(ref, (snap) => {
      if (snap.exists()) {
        setUserData(snap.data());
      } else {
        setUserData(null);
      }
    });

    return () => unsub();
  }, [user]);

  // existing payment-success fix stays as you already have it
  useEffect(() => {
    if (location.pathname !== "/payment-success") return;

    const params = new URLSearchParams(location.search);
    const orderId = params.get("order_id");
    if (!orderId) {
      const timer = setTimeout(() => {
        window.location.reload();
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [location]);

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/pricing" element={<Pricing userData={userData} />} />
      <Route path="/instructions" element={<Instructions />} />
      <Route path="/about" element={<AboutCompany />} />
      <Route path="/TermsConditions" element={<TermsConditions />} />
      <Route path="/Contact" element={<ContactInfo />} />
      <Route path="/PaymentandRefundPolicy" element={<PaymentandRefundPolicy />} />
      <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
    </Routes>
  );
}


// App wrapper
function App() {
  const lightTheme = createTheme({
    palette: {
      mode: 'light',
      primary: { main: '#39AED9' },
      background: {
        default: '#f6f9fe',
        paper: '#fff'
      },
      text: { primary: '#201d32' },
      secondary: { main: '#D4AF37' }
    }
  });

  return (
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      <Router>
        <Navbar />
        <ProtectedRouter />

        {/* 👇 Add this footer so homepage visibly links to Privacy Policy */}
        <footer
          style={{
            marginTop: 40,
            padding: '18px 0',
            textAlign: 'center',
            fontSize: 14,
            color: '#7b8aa5',
            borderTop: '1px solid #d3e7fa',
            background: '#f6fbff',
          }}
        >
          <span>© {new Date().getFullYear()} RealAgentApp.</span>{' '}
          <Link
            to="/PrivacyPolicy"
            style={{
              color: '#39AED9',
              textDecoration: 'none',
              fontWeight: 600,
              marginLeft: 8,
            }}
          >
            Privacy Policy
          </Link>
          {' · '}
          <Link
            to="/TermsConditions"
            style={{
              color: '#39AED9',
              textDecoration: 'none',
              fontWeight: 600,
              marginLeft: 4,
            }}
          >
            Terms and Conditions
          </Link>
        </footer>
      </Router>
    </ThemeProvider>
  );
}


export default App;
